import { Component } from '@angular/core';
import { User } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser } from './../../../../viewbid/state/app-selectors';
import { AppState } from './../../../../viewbid/state/app-state';
@Component({
    selector: 'vb-site-map-page',
    templateUrl: './site-map-page.component.html',
    styleUrls: ['./site-map-page.component.scss'],
})
export class SiteMapPageComponent {
    public user: User | null = null;
    public user$: Observable<User | null> | undefined;
    isSignedIn: boolean = false;

    constructor(private store: Store<AppState>) {
        this.user$ = this.store.select<User | null>(selectUser);
        this.user$.subscribe((user: User | null) => {
            this.user = user;
        });
    }
}
